import Vue from 'vue'
import { AxiosBasicCredentials } from 'axios'
import { IAuthData, IUser, ICustomer } from '@/features/auth/store'
import { ALLOWED_ROLES } from '@/constants'
const {
  VUE_APP_SCPRF_ENDPOINT,
  VUE_APP_SCPRF_CLIENT_ID,
  VUE_APP_ENDPOINT,
  VUE_APP_SCBACK_ENDPOINT
} = process.env

/* eslint-disable */
interface BaseAuthParams {
  client_id: string
  redirect_uri: string
  response_type: 'token'
}
interface IRawCustomer extends ICustomer {
  archived_utc?: string
}
/* eslint-enable */

export default class AuthService extends Vue {
  private scprfEndpoint: string
  private scbackEndpoint: string

  constructor () {
    super()
    this.scprfEndpoint = VUE_APP_SCPRF_ENDPOINT
    this.scbackEndpoint = VUE_APP_SCBACK_ENDPOINT
  }

  async getAuthUser (token: string): Promise<IUser | Error> {
    const url: string = 'user/me'
    const baseURL = this.scprfEndpoint
    const { data } = await this.$http.get(url, {
      baseURL,
      headers: {
        Authorization: `Bearer ${token}`
      }
    })

    const {
      id,
      uuid,
      profile: {
        firstname,
        lastname
      },
      role: {
        name: role
      }
    } = data

    if (!ALLOWED_ROLES.includes(role)) throw new Error('Access denied')

    return { id, uuid, role, name: `${firstname} ${lastname}` }
  }

  async authorise (auth: AxiosBasicCredentials): Promise<IAuthData> {
    const url: string = 'oauth2/authorize'
    const baseURL = this.scprfEndpoint
    const params: BaseAuthParams = {
      client_id: (VUE_APP_SCPRF_CLIENT_ID as string),
      redirect_uri: (VUE_APP_ENDPOINT as string),
      response_type: 'token'
    }

    const { data: tokenData } = await this.$http.get(url, {
      baseURL,
      params,
      auth
    })

    // eslint-disable-next-line
    const { access_token: token, expires_in: expiresIn } = tokenData

    return {
      token,
      expiresAt: Date.now() + expiresIn
    }
  }

  async getCustomers (token: string): Promise<IRawCustomer[]> {
    const url: string = 'organisation'
    const baseURL = this.scbackEndpoint
    const { data } = await this.$http.get(url, {
      baseURL,
      headers: {
        Authorization: `Bearer ${token}`
      }
    })

    return data.docs
  }
}
